var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2008 11.2923C29.7392 8.50769 27.2777 6.49231 24.2623 5.64615C22.1392 5.04615 20.4623 5 20.0008 5C18.6162 5 17.2469 5.18462 15.9239 5.55385C12.9239 6.38462 10.4315 8.4 8.90846 11.2615C7.32385 14.2308 7.03154 17.7385 8.13923 21.0462C9.73923 25.7538 12.4315 29.9385 16.1546 33.4615C17.2315 34.4923 18.6162 35 20.0008 35C21.3854 35 22.77 34.4923 23.8469 33.4615C27.57 29.9231 30.2623 25.7538 31.8931 20.9538C32.9854 17.7385 32.7238 14.2308 31.2008 11.3077V11.2923ZM29.6777 20.2923C28.2008 24.6462 25.7085 28.5077 22.2623 31.7846C20.97 33.0154 19.0315 33.0154 17.7392 31.7846C14.2931 28.5077 11.8008 24.6462 10.2777 20.1692C9.41616 17.6 9.66231 14.7538 10.9546 12.3538C12.17 10.0615 14.1546 8.44615 16.5392 7.78462C17.6623 7.47692 18.8315 7.32308 20.0008 7.32308C20.3854 7.32308 21.8008 7.36923 23.6315 7.89231C26.0162 8.56923 27.9854 10.1692 29.1546 12.4C30.4008 14.7538 30.6008 17.6154 29.6777 20.3231V20.2923Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0017 11.1538C16.817 11.1538 14.2324 13.7384 14.2324 16.923C14.2324 20.1077 16.817 22.6923 20.0017 22.6923C23.1863 22.6923 25.7709 20.1077 25.7709 16.923C25.7709 13.7384 23.1863 11.1538 20.0017 11.1538ZM20.0017 20.3846C18.094 20.3846 16.5401 18.8307 16.5401 16.923C16.5401 15.0153 18.094 13.4615 20.0017 13.4615C21.9093 13.4615 23.4632 15.0153 23.4632 16.923C23.4632 18.8307 21.9093 20.3846 20.0017 20.3846Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.518b7811.svg";
export { ForwardRef as ReactComponent };